import { LanguageCode, LANGUAGES } from './translations';

/**
 * Gets the browser's language and matches it with our supported languages.
 * Returns 'en' if no match is found.
 */
export function detectLanguage(): LanguageCode {
  // Get the browser language (e.g., 'en-US', 'es-ES', 'pt-BR')
  const browserLang = navigator.language.toLowerCase();
  
  // First try to match exact language codes (for variants like pt-BR)
  if (browserLang in LANGUAGES) {
    return browserLang as LanguageCode;
  }

  // Then try to match the primary language code (e.g., 'en' from 'en-US')
  const primaryLang = browserLang.split('-')[0];
  
  // Special handling for Portuguese
  if (primaryLang === 'pt') {
    // If it's Brazilian Portuguese, use pt-BR, otherwise use pt-PT
    return browserLang.startsWith('pt-br') ? 'pt-BR' : 'pt-PT';
  }

  // Map browser language codes to our language codes
  const languageMap: Record<string, LanguageCode> = {
    en: 'en',
    ca: 'ca',
    es: 'es',
    fr: 'fr',
    it: 'it',
    de: 'de',
    nl: 'nl',
    sv: 'sv',
    pl: 'pl',
    nb: 'no', // Norwegian Bokmål
    nn: 'no', // Norwegian Nynorsk
    no: 'no'  // Norwegian
  };

  return languageMap[primaryLang] || 'en';
} 